import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@domestika-dev/prudencio/dist/molecules/Modal";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex, Grid } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon/Icon";
import { ExclamationCircle } from "@domestika-dev/prudencio/dist/atoms/Icons";
import When from "../../../common/When";

export const LiveSessionConfirmationModal = ({
  isOpen,
  showWarningIcon,
  title,
  body,
  cancelMessage,
  confirmMessage,
  onConfirm,
  onCancel,
}) => (
  <Modal
    width="auto"
    heigth="auto"
    isOpen={isOpen}
    id="dmstk-live-session-confirmation-modal"
    onModalClose={onCancel}
  >
    <Modal.Content>
      <Flex alignItems="center" flexDirection="column" justifyContent="center">
        <When condition={showWarningIcon}>
          {() => (
            <IconForm size="gigantic">
              <ExclamationCircle />
            </IconForm>
          )}
        </When>
        <Text as="h1" textAlign="center" size="large" fontWeight="medium" marginTop={5}>
          {title}
        </Text>
        <Text size="micro" textAlign="center" marginTop={5}>
          {body}
        </Text>
        <Modal.Actions>
          <Grid
            gridTemplateColumns="1fr 1fr"
            gridTemplateRows="1fr"
            gridColumnGap={3}
            marginTop={5}
          >
            <Button size="medium" hollow="secondary" id="cancel-button">
              <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="sonar">
                {cancelMessage}
              </Text>
            </Button>
            <Button size="medium" action={onConfirm}>
              <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
                {confirmMessage}
              </Text>
            </Button>
          </Grid>
        </Modal.Actions>
      </Flex>
    </Modal.Content>
  </Modal>
);

LiveSessionConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  showWarningIcon: PropTypes.bool,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  cancelMessage: PropTypes.string.isRequired,
  confirmMessage: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

LiveSessionConfirmationModal.defaultProps = {
  isOpen: false,
  showWarningIcon: false,
};

export default LiveSessionConfirmationModal;
